// extracted by mini-css-extract-plugin
export default {"footer":"CardWithBrandLogo_footer__zQeDH","space":"CardWithBrandLogo_space__CTi14","logo":"CardWithBrandLogo_logo__995cH"};